import { placementConfigs } from './ad_ops/adPlacementMappings'

export default defineAppConfig({
  nuxtIcon: {},
  siteName: 'OneNews',
  defaultCpm: 2.0,
  urls: {
    home: '/',
    article: '/article',
    video: '/video',
  },
  directAdsHostedConfigUrl:
    'http://localhost:2772/applications/WebTier/environments/OneNews/configurations/OneNews-DirectAds',
  redesignedNtpPaths: ['/v8', '/v8/article', '/', '/article'],
  googleTagManagerId: 'GTM-WNFNMPW',
  outbrain: {
    installationKey: 'ONELA2JBJF199O5BKEIEEDG98',
  },
  adops: {
    placements: placementConfigs,
  },
  taboola: {
    publisherName: 'rebasetechinc-network',
  },
})
